import { useCallback, useMemo } from 'react';
import { atom, useRecoilState } from 'recoil';

export interface TranslatableContentState {
  originalLanguage?: string;
  targetLanguage?: string;
}

export const translatableContentState = atom<TranslatableContentState>({
  key: 'translatableContentState',
  default: {
    originalLanguage: undefined,
    targetLanguage: undefined,
  },
});

export const useTranslatableContentState = () => {
  const [state, setState] = useRecoilState(translatableContentState);

  const setTargetLang = useCallback(
    (lang?: string) => {
      setState({ ...state, targetLanguage: lang });
    },
    [setState, state],
  );

  const setOriginalLang = useCallback(
    (lang?: string) => {
      setState({ ...state, originalLanguage: lang });
    },
    [setState, state],
  );

  const cancelTranslation = useCallback(() => {
    setState({ ...state, targetLanguage: undefined });
  }, [setState, state]);

  return {
    ...state,
    setState,
    setTargetLang,
    setOriginalLang,
    cancelTranslation,
  };
};
